import BaseRenderer from "./BaseRenderer";
import { ICompetition } from "../models/Competition";
import { Player } from "../algorithms/managers/ICompetitionManager";
import { Pairing } from "../models/Pairing";

export default class SwissSystemRenderer extends BaseRenderer {
}
